// extracted by mini-css-extract-plugin
export default {"host":"AssetDetail_host__dOwGW","preview":"AssetDetail_preview__1J5+Z","img":"AssetDetail_img__37deK","details":"AssetDetail_details__SerpK"};